import { Injectable } from '@angular/core';

import { ApiProvider } from '../api/api';
import { MessageModel } from '../../models/message';
import { OpsOrderModel } from '../../models/order.ops';

@Injectable()
export class MessageProvider {
  constructor(private api: ApiProvider) {}

  sendMessageToCustomer(
    order: OpsOrderModel,
    type: FillerMessageTypes,
    keyMap: object
  ) {
    const key = type + order.uid;
    const message = messageForOrder(type, order);
    if (message) {
      return this.sendMessageToUser(order.user.uid, message, true).finally(
        () => (keyMap[key] = true)
      );
    }
  }

  getMessagesForUser(uid: string) {
    return this.api
      .call({
        url: `/fillers/users/${uid}/short_messages`,
        method: 'GET',
        ops: true,
      })
      .map(result => {
        let messages = result.map(item => new MessageModel(item));
        this.sortMessagesByDate(messages);
        return messages;
      });
  }

  private sortMessagesByDate(messages: MessageModel[]) {
    messages.sort(function(a, b) {
      let timeA = a.createdAt ? a.createdAt.getTime() : -1;
      let timeB = b.createdAt ? b.createdAt.getTime() : -1;
      return timeA - timeB;
    });
  }

  private sendMessageToUser(
    uid: string,
    message: string,
    automatic_message = false
  ) {
    return this.api
      .call({
        url: `/fillers/users/${uid}/short_messages`,
        method: 'POST',
        ops: true,
        params: { message: message, automatic_message: automatic_message },
      })
      .map(data => new MessageModel(data));
  }
}

export enum FillerMessageTypes {
  OwnerRequired = 'owner_required_',
  OwnerRequired2ndAttempt = 'owner_required_2nd_attempt_',
}

export type FillerMessageMap = { [key in FillerMessageTypes]: string };

export const fillerMessageConfirmation: FillerMessageMap = {
  [FillerMessageTypes.OwnerRequired]: 'request owner',
  [FillerMessageTypes.OwnerRequired2ndAttempt]: '2nd request owner',
};

export const fillerServiceLabels: FillerMessageMap = {
  [FillerMessageTypes.OwnerRequired]: 'Request Owner',
  [FillerMessageTypes.OwnerRequired2ndAttempt]: 'Request Owner 2nd Attempt',
};

const enum TemplateVars {
  TechnicianTerm = 'TECHNICAL_TERM',
  VehicleModel = 'VEHICLE_MODEL',
  ServiceTitle = 'SERVICE_TITLE',
  OwnerRequiredContext = 'OWNER_REQUIRED_CONTEXT',
  OwnerRequired2ndAttemptContext = 'OWNER_REQUIRED_2ND_ATTEMPT_CONTEXT',
}

export const fillerMessages: FillerMessageMap = {
  [FillerMessageTypes.OwnerRequired]: `Hi! The Yoshi ${TemplateVars.TechnicianTerm} ${TemplateVars.OwnerRequiredContext}`,
  [FillerMessageTypes.OwnerRequired2ndAttempt]: `Hi! The Yoshi ${TemplateVars.TechnicianTerm} ${TemplateVars.OwnerRequired2ndAttemptContext}`,
};

function messageForOrder(type: FillerMessageTypes, order: OpsOrderModel) {
  let message = fillerMessages[type];
  const templateVarMap: { [key in TemplateVars]: string } = {
    [TemplateVars.TechnicianTerm]: order.service.technicianTitle,
    [TemplateVars.VehicleModel]: order.vehicle.vehicleModel.model,
    [TemplateVars.ServiceTitle]: order.service.serviceType.name,
    [TemplateVars.OwnerRequiredContext]: order.virtual
      ? `is waiting for you in the Zoom call. Can you join the link?`
      : `has arrived. Can you come out to meet them?`,
    [TemplateVars.OwnerRequired2ndAttemptContext]: order.virtual
      ? `is waiting for you in the Zoom call and needs you to be present for the ${order.service.serviceType.name}. Can you join the link?`
      : `has arrived and and needs you to be present for the ${order.service.serviceType.name}. Are you able to come out to meet them?`,
  };
  for (let key in templateVarMap) {
    const value = templateVarMap[key];
    message = message.replace(key, value);
  }
  return message;
}



// WEBPACK FOOTER //
// ./src/providers/message/message.ts